import React from 'react';
import { useSpring, animated } from 'react-spring';

const FadeIn = ({ children, open = true, ...props }) => {
	const styleFade = useSpring({
		opacity: 1,
		from: { opacity: 0.25 },
		config: { duration: 1000 },
	});

	return (
		<animated.div style={styleFade} {...props}>
			{children}
		</animated.div>
	);
};

export default FadeIn;
